import { render, staticRenderFns } from "./DepartmentLinks.vue?vue&type=template&id=3cfaa76a&"
import script from "./DepartmentLinks.vue?vue&type=script&lang=js&"
export * from "./DepartmentLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports